import { render, staticRenderFns } from "./BridgeAlertRuleDrawer.vue?vue&type=template&id=476a1997&scoped=true"
import script from "./BridgeAlertRuleDrawer.vue?vue&type=script&lang=js"
export * from "./BridgeAlertRuleDrawer.vue?vue&type=script&lang=js"
import style0 from "./BridgeAlertRuleDrawer.vue?vue&type=style&index=0&id=476a1997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a1997",
  null
  
)

export default component.exports